import { render, staticRenderFns } from "./DmqPriceFilter.vue?vue&type=template&id=0509588a&"
import script from "./DmqPriceFilter.vue?vue&type=script&lang=ts&"
export * from "./DmqPriceFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DmqPriceFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports